import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { GetTagSeparacaoResponse } from '../../responses/vendas/get-tag-separacao.response';
import { CreateTagSeparacaoResponse } from '../../responses/vendas/create-tag-separacao.response';
import { TagSeparacaoRequest } from '../../requests/vendas/tag-separacao.request';
import { ReturnStruct } from '../../structs/return.struct';

@Injectable({
    providedIn: 'root',
})
export class TagSeparacaoService extends CommonService {
    private readonly apiUrl: string = environment.urlApiVendas + 'TagSeparacao';

    constructor(private httpClient: HttpClient) {
        super();
    }

    public getAll(descricao: string = '', pagina: number = 1, tamanhoPagina: number = 20): Observable<GetTagSeparacaoResponse> {
        let params = new HttpParams()
            .set('pagina', pagina.toString())
            .set('tamanhoPagina', tamanhoPagina.toString());

        if (descricao) {
            params = params.set('descricao', descricao);
        }

        return this.httpClient
            .get<GetTagSeparacaoResponse>(this.apiUrl, { params, ...this.addHeaderToken() })
            .pipe(catchError(this.handleError));
    }

    public getById(id: number): Observable<CreateTagSeparacaoResponse> {
        const url = `${this.apiUrl}/idTagSeparacao/${id}`;
        return this.httpClient
            .get<CreateTagSeparacaoResponse>(url, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public create(request: TagSeparacaoRequest): Observable<CreateTagSeparacaoResponse> {
        return this.httpClient
            .post<CreateTagSeparacaoResponse>(this.apiUrl, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public update(id: number, request: TagSeparacaoRequest): Observable<CreateTagSeparacaoResponse> {
        const url = `${this.apiUrl}/idTagSeparacao/${id}`;
        return this.httpClient
            .put<CreateTagSeparacaoResponse>(url, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public delete(id: number): Observable<ReturnStruct> {
        const url = `${this.apiUrl}/idTagSeparacao/${id}`;
        return this.httpClient
            .delete<ReturnStruct>(url, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public deleteBulk(ids: number[]): Observable<ReturnStruct> {
        const url = `${this.apiUrl}/bulk-delete`;
        return this.httpClient
            .post<ReturnStruct>(url, { ids }, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }
}
